import React from 'react';
import Link from 'gatsby-link';
import { css } from 'glamor';
import Parser from 'html-react-parser';

import { Grid, GridCell } from 'rmwc/Grid';
import { Icon } from 'rmwc/Icon';

import styled from 'styled-components';
import trimpath from '../../trimpath';

const listStyle = css({
  listStyle: 'none',
  minWidth: '10rem',
  marginLeft: 0,
  alignSelf: 'flex-start',
  color: 'white',
  marginTop: '1.5rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  borderLeft: '1px dashed hsla(0,0%,78%,.5)',
  '& a': { color: 'white', textDecoration: 'none' },
  '& a:hover': { textDecoration: 'underline' },
});

const StyledFooter = styled.footer`
  background: radial-gradient(ellipse at center, #1a5276, #11354c);
  padding: 4em 0;
  minheight: 10rem;
  color: white;
  display: 'block';
  width: 100%;
`;

const footer__logo = css({
  width: '18em',
  fontSize: '12px',
  lineHeight: '.2em',
  marginTop: 0,
  textAlign: 'center',
});

const FooterList = styled.ul`
  list-style: none;
  margin: 0;
  font-weight: 800;

  .children {
    font-weight: 400;
  }

  li {
    line-height: 1.3rem;
    margin-bottom: 1rem;
  }

  a {
    color: white;
    border-bottom: 1px solid transparent;
  }

  a:hover,
  a:focus {
    color: white;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.29);
  }
`;

const Address = styled.p`
  margin-top: 0.5rem;
  & span {
    display: block;
  }
`;

const FooterTitle = styled.h2`
  border-bottom: 1px solid rgba(255, 255, 255, 0.29);
`;

const FooterText = styled.div`
  a,
  a:hover,
  a:focus {
    color: white;
  }
`;

const TLED = styled.svg`
  display: block;
  width: 150px;
  height: 100px;
  margin-top: 1rem;
`;

const Report = styled.a`
  text-decoration: underline;
  color: #fff;
`;

const Footer = props => (
  <StyledFooter>
    <Grid style={{ maxWidth: '960px' }}>
      <GridCell span="6" phone="4" tablet="8">
        <FooterList>
          {props.listItems.map((item, index) => {
            if (item.wordpress_children) {
              return (
                <li key={`footerMenu_${item.url}_${index}`}>
                  <a href={trimpath(item.url)}>{item.title}</a>
                  <ul className="children">
                    {item.wordpress_children.map(child => (
                      <li key={child.url}>
                        <a href={trimpath(child.url)}>{child.title}</a>
                      </li>
                    ))}
                  </ul>
                </li>
              );
            }
            return (
              <li key={`footerMenu_${item.url}_${index}`}>
                <a href={trimpath(item.url)}>{item.title}</a>
              </li>
            );
          })}
        </FooterList>
      </GridCell>

      <GridCell span="6" phone="4" tablet="8">
        <FooterTitle>{props.text.edges[0].node.title}</FooterTitle>
        <FooterText>{Parser(props.text.edges[0].node.content)}</FooterText>
      </GridCell>

      <GridCell span="6">
        <TLED xmlns="http://www.w3.org/2000/svg" viewBox="0 0 415.3 228.7">
          <title>Teaching and Learning Excellence Division Logo</title>
          {/* star */}
          <g fill="white">
            <path d="M145.7 133.6c-18.7-15.4-37.3-30.8-56-46.2 1.8-10 3.5-20 5.3-30.1 29.9-7.5 59.7-14.9 89.6-22.4 0 .1.1.1.1.2C161.8 50.4 139 65.6 116 81c10 17.5 20 35 29.9 52.5-.1 0-.1.1-.2.1z" />
            <path d="M30.1 135.5c1.9-4.1 3.9-8.2 5.9-12.3 7.8-16.1 15.6-32.2 23.3-48.3.2-.4.3-.7.5-1.2-14.1-9.3-28.3-18.6-42.4-27.9 0-.1.1-.2.1-.3 21.3 4.3 42.7 8.6 64.2 13-.9 7.4-1.9 14.7-2.8 22-11.1 12.6-22.2 25.2-33.2 37.8-5.1 5.8-10.3 11.6-15.4 17.4l-.2-.2z" />
            <path d="M146.8 142.5c-.4-.1-.8-.2-1.2-.4-18.3-9-36.5-18-54.8-27.1-2-1-3.8-1.3-6.1-.7-12.2 3-24.5 5.8-36.8 8.7-.3.1-.5.1-.9 0 14.3-8.9 28.5-17.8 42.8-26.7 2.9 2.4 5.8 4.7 8.7 7 15.8 12.9 31.6 25.7 47.4 38.6.4.1.7.4.9.6z" />
            <path d="M87.6 11.7c9.6 9.2 19.1 18.3 28.7 27.5-11.1 2.8-22 5.6-33.1 8.4 1.4-12 2.9-23.8 4.4-35.9z" />

            {/*
      <path fill="#0084CB" d="M145.7 133.6c-18.7-15.4-37.3-30.8-56-46.2 1.8-10 3.5-20 5.3-30.1 29.9-7.5 59.7-14.9 89.6-22.4 0 .1.1.1.1.2C161.8 50.4 139 65.6 116 81c10 17.5 20 35 29.9 52.5-.1 0-.1.1-.2.1z" />
      <path fill="#E33E46" d="M30.1 135.5c1.9-4.1 3.9-8.2 5.9-12.3 7.8-16.1 15.6-32.2 23.3-48.3.2-.4.3-.7.5-1.2-14.1-9.3-28.3-18.6-42.4-27.9 0-.1.1-.2.1-.3 21.3 4.3 42.7 8.6 64.2 13-.9 7.4-1.9 14.7-2.8 22-11.1 12.6-22.2 25.2-33.2 37.8-5.1 5.8-10.3 11.6-15.4 17.4l-.2-.2z" />
      <path fill="#FFCE0A" d="M146.8 142.5c-.4-.1-.8-.2-1.2-.4-18.3-9-36.5-18-54.8-27.1-2-1-3.8-1.3-6.1-.7-12.2 3-24.5 5.8-36.8 8.7-.3.1-.5.1-.9 0 14.3-8.9 28.5-17.8 42.8-26.7 2.9 2.4 5.8 4.7 8.7 7 15.8 12.9 31.6 25.7 47.4 38.6.4.1.7.4.9.6z" />
      <path fill="#00AA86" d="M87.6 11.7c9.6 9.2 19.1 18.3 28.7 27.5-11.1 2.8-22 5.6-33.1 8.4 1.4-12 2.9-23.8 4.4-35.9z" />
      */}
          </g>

          {/* text */}
          <g fill="white">
            {/* ACC */}
            <path d="M243.4 130.8h-25.7c.7-.8 1.4-1.5 2-2.2 1.7-1.8 2.2-3.9 1.3-6.3-2.1-5.6-4.1-11.1-6.2-16.7-1-2.7-2-5.4-3.1-8.1h-32.8l-3.6 8.7c-1.7 4-3.4 8-5 12-.6 1.7-1 3.5-1.3 5.3-.3 2.3.8 4.1 2.4 5.7.5.5 1 .9 1.6 1.5h-20.9v-.2c4.4-3 6.4-7.7 8.3-12.4 8.5-21.3 17-42.7 25.4-64.1.7-1.9 1.2-4 1.5-6 .5-2.6-.8-4.5-2.9-6.1h20.2c1.3 3.4 2.6 6.9 3.9 10.4 8 21.2 15.9 42.5 24 63.7 2.4 5.8 5.6 10.9 10.9 14.8zm-61.1-42.3h26.2c-4.2-11.4-8.3-22.7-12.5-34.3-4.6 11.6-9.1 22.9-13.7 34.3z" />
            <path d="M383.9 43.1v14.1c-.3-.1-.5-.2-.7-.3-6.8-3.4-13.9-5.9-21.6-5.9-9.5.1-17.9 3.1-24.4 10.3-4.1 4.5-6.4 9.8-7.4 15.7-1.4 8.4-.8 16.6 2.4 24.5 5.2 13 16.7 20.2 31 20.1 8.5-.1 16.1-2.7 23.5-6.6 1.5-.8 3-1.6 4.8-2.6-2.3 5.5-4.5 10.8-6.6 16-13.9 4.9-27.9 6-41.9.7-15.8-6-25.3-17.3-28.4-34-5.1-26.9 13.4-47 31.1-52.8 8.9-3 18-3.7 27.3-1.8 3.5.7 7 1.5 10.5 2.3 0 .1.2.2.4.3zM305.2 42.9v14.3c-.6-.3-1.2-.5-1.7-.8-5.2-2.6-10.5-4.6-16.3-5.3-16-1.8-29.7 6-34.7 20.3-1.9 5.4-2.2 10.9-1.9 16.6.4 6.5 1.8 12.7 5.2 18.3 6 9.6 14.7 14.6 25.9 15.3 7 .5 13.6-1.1 19.9-3.8 3.6-1.6 7.1-3.3 10.7-5-2.1 5.1-4.2 10.3-6.3 15.6-4.6 1.7-9.4 3-14.3 3.7-12.5 1.8-24.3-.3-35.2-6.5-9.1-5.1-15.5-12.8-18.8-22.6-6.1-18.2-2.8-34.6 10.4-48.7 7.4-7.9 16.6-12.4 27.2-14.1 10.3-1.6 20.1-.1 29.9 2.7z" />

            {/* TLED */}
            <g stroke="white">
              <path d="M203.4 168.2c-2.6-4.1-2.5-7.3.5-9 2.8-1.7 6.6-.8 8 1.8 1.7 3.1.3 5.7-4.4 8 .8.8 1.5 1.6 2.3 2.4.8.8 1.6 1.6 2.5 2.6.9-1.7 1.7-3.2 2.6-4.8.6.3 1.3.6 2.1 1-1 1.9-2 3.6-3.2 5.7 1.2 1.1 2.6 2.2 4 3.4-.8.7-1.4 1.1-2.1 1.6-1.1-1.2-2.2-2.3-3.3-3.5-.6.5-1.1.9-1.5 1.3-2.6 2-5.4 2.6-8.6 1.6-2.1-.7-3.5-2.2-3.9-4.4-.4-2.3.2-4.3 2.1-5.8.9-.8 1.9-1.3 2.9-1.9zm7.5 7.5c-2.1-1.9-4.1-3.7-6.2-5.7-.6.3-1.5.8-2.2 1.4-1.2 1-1.8 2.3-1.5 3.9.4 1.7 1.5 2.7 3.1 3.1 2.7.6 4.8-.6 6.8-2.7zm-4.7-8c1.1-.8 2.3-1.4 3.2-2.3 1-1 1-2.6.2-3.7-.7-1.1-2.2-1.6-3.6-1.1-1.3.4-2.1 1.6-2.1 3 0 1.6 1.1 2.7 2.3 4.1z" />
              <path d="M348.4 205.7c0-6.5 4.7-11.3 11.2-11.3 6.3 0 10.9 4.8 10.9 11.3 0 6.5-4.8 11.3-11.3 11.2-6.2 0-10.8-4.8-10.8-11.2zm2.6-.3c0 6.1 5.1 10.3 10.5 9 3.3-.8 5.4-3 6.2-6.2.9-3.5.2-6.8-2.5-9.3-2.6-2.4-5.8-2.9-9-1.5-3.7 1.5-5.1 4.5-5.2 8z" />
              <path d="M359.9 162.8v17.6h-2.3V159h2.3c4.3 5.5 8.8 11.2 13.4 17.1V159h2.4v21.5h-2c-4.5-5.9-9-11.7-13.8-17.7zM186.4 212.1v-17.2h2.3v21.5h-2c-4.5-5.8-9-11.5-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.9 11.2 13.5 17.2zM392 194.9h2.4v21.5h-2c-4.5-5.7-9-11.5-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.8 11.3 13.4 17.1v-17.1zM142 162.8v17.6h-2.3v-21.5h2.3c4.4 5.6 8.8 11.2 13.4 17.1v-17.1h2.4v21.5h-2c-4.5-5.8-9-11.5-13.8-17.6zM340.7 180.4h-2c-4.5-5.8-9.1-11.6-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.8 11.3 13.4 17.1v-17.1h2.4v21.5z" />
              <path d="M251.2 194.7c3.4.1 6.8 0 10.2.5 5.1.7 8.7 5.1 8.8 10.1.2 5.6-3.5 10.2-8.8 10.9-3.3.4-6.8.1-10.2.1v-21.6zm2.4 19.3c2.2 0 4.3.1 6.4 0 3.6-.2 6.5-2.8 7.3-6.4.9-3.6-.6-7.3-3.6-9.2-3.2-2-6.7-1.2-10.1-1.4v17z" />
              <path d="M307.8 172.1h-6.2v8.3h-2.4v-21.7c3.9.1 7.7 0 11.6.4 3.3.3 5.3 2.7 5.5 5.6.2 3.5-1.3 5.6-4.8 6.7-.3.1-.5.2-.8.3 2.2 2.9 4.3 5.7 6.5 8.7h-3.1c-2.1-2.8-4.2-5.6-6.3-8.3zm-6.1-2.5c2.8 0 5.5.2 8.2 0 2.4-.2 4-2.1 4-4.2s-1.5-3.9-3.8-4.1c-2.8-.2-5.6-.1-8.4-.1v8.4z" />
              <path d="M181.4 176.5v-5.4H175v-2.2h8.8v8.7c-4.9 4.4-12.6 4.4-16.7 0-4.1-4.3-3.9-12.1.3-16.3 4.1-4 11.4-4.1 15.6-.1-.5.6-1 1.2-1.5 1.9-2.4-2.1-5.1-2.9-8.2-2.3-2 .3-3.5 1.4-4.7 3-2.8 3.6-2.4 9.4.8 12.5 2.9 3.1 8.1 3.2 12 .2z" />
              <path d="M400.7 161.3l-1.5 1.8c-5-4.1-10.4-2.5-12.8.5-2.8 3.5-2.7 9.4.3 12.6 3.1 3.3 8.4 3.4 12.3.3v-5.4h-6.5v-2.2h8.8v8.6c-4.4 4.4-12.4 4.5-16.6.3-4.3-4.4-4.1-12.3.3-16.6 4.2-3.9 11.8-3.9 15.7.1z" />
              <path d="M37.4 194.9v2.2H24.3v7.3H36v2.2H24.2v7.6h13.3v2.2H21.7v-21.5h15.7z" />
              <path d="M90.7 204.4h11.8v2.1H90.8v7.6h13.3v2.2H88.3v-21.4h15.6v2.1H90.8c-.1 2.5-.1 4.9-.1 7.4z" />
              <path d="M151.7 206.5v7.6H165v2.3h-15.8v-21.5h15.6v2.2h-13.1v7.2h11.8v2.2h-11.8z" />
              <path d="M233.5 204.3v2.2h-11.8v7.6H235v2.2h-15.8v-21.5h15.6v2.2h-13.1v7.2c3.9.1 7.8.1 11.8.1zM252.4 180.4V159H268v2.1h-13.1v7.3h11.7v2.2h-11.7v7.6h13.3v2.2h-15.8z" />
              <path d="M52 158.9v2.2H38.9v7.3h11.7v2.2H38.8v7.6h13.3v2.2H36.3v-21.5H52z" />
              <path d="M277.2 174.7c-.8 1.9-1.7 3.7-2.5 5.7h-2.6c3.3-7.3 6.6-14.5 9.9-21.8h2.4c3.3 7.2 6.6 14.5 9.9 21.8h-2.7c-.8-1.8-1.7-3.7-2.5-5.7h-11.9zm10.8-2.3c-1.6-3.6-3.2-7.1-4.9-10.9-1.7 3.8-3.3 7.3-4.9 10.9h9.8zM65.9 158.6h2.4c3.3 7.2 6.5 14.4 9.9 21.8h-2.7c-.8-1.8-1.7-3.7-2.5-5.6H61.3c-.8 1.9-1.7 3.8-2.6 5.7h-2.6c3.3-7.4 6.5-14.6 9.8-21.9zm6.1 13.8c-1.6-3.6-3.2-7.1-4.9-10.9-1.7 3.8-3.3 7.3-4.9 10.9H72z" />
              <path d="M120.5 170.7H108v9.6h-2.4v-21.5h2.3v9.4h12.5v-9.4h2.5v21.5h-2.3c-.1-3.1-.1-6.3-.1-9.6z" />
              <path d="M317.6 213.2c.6-.7 1.1-1.3 1.6-1.9 1.9 1.7 4.1 2.9 6.6 3 1.5.1 2.9-.1 4.1-1 2-1.5 1.9-4.3-.4-5.4-1.4-.7-2.9-1-4.4-1.4-1.1-.4-2.3-.7-3.4-1.1-1.9-.8-3.1-2.2-3.2-4.5-.1-2.5.9-4.3 3-5.4 3.1-1.6 6.2-1.2 9.2.1.8.4 1.6.9 2.5 1.5-.5.7-1 1.4-1.5 2-2.3-1.7-4.7-2.7-7.5-2.2-1.3.3-2.4.9-3 2.1-.6 1.4-.2 3.1 1.3 3.8 1.3.7 2.8 1 4.3 1.5 1.2.4 2.5.7 3.7 1.2 2 .9 3.2 2.3 3.3 4.6.1 2.5-.9 4.4-3.1 5.5-4.1 1.9-8 1-11.7-1.4-.4-.2-.8-.6-1.4-1z" />
              <path d="M57.8 194.8h3c-2.7 3.6-5.3 7-8 10.6 2.7 3.6 5.4 7.2 8.2 10.9h-3c-2.2-2.9-4.5-6-6.8-9.1-2.3 3.1-4.6 6.2-6.9 9.2h-2.9c2.8-3.7 5.5-7.3 8.3-11-2.6-3.5-5.2-6.9-7.9-10.5h3c2.1 2.8 4.3 5.7 6.5 8.7 2.2-2.9 4.4-5.8 6.5-8.8zM99 175.5l1.5 1.5c-2.9 4.5-10.7 5.3-15.4 1.7-5-3.9-5.6-12.1-1.2-16.9 4.3-4.7 12.1-4.6 16.5.1-.5.6-1.1 1.2-1.7 1.8-2.3-2.2-4.9-3.4-8.1-2.9-1.9.3-3.5 1.2-4.8 2.7-3.1 3.6-2.9 9.2.2 12.6 2.6 2.7 8 4.2 13-.6zM81.7 211.5c.5.5 1 1 1.5 1.4-1.9 3.1-6.9 4.7-11.3 3.7-4.3-1-7.7-4.9-8.2-9.6-.5-5.2 2-9.8 6.4-11.8 4.3-2 9.7-.9 13 2.6-.5.6-1.1 1.2-1.7 1.8-2.3-2.3-5-3.4-8.2-2.9-2 .3-3.7 1.3-4.9 2.9-2.9 3.6-2.6 9.2.6 12.5 2.6 2.8 8 4.1 12.8-.6z" />
              <path d="M214.3 197.8c-.6.6-1.1 1.2-1.7 1.8-4.9-4.6-10.1-3.2-12.7-.5-3.3 3.4-3.3 9.3-.2 12.8 2.8 3.1 8.3 4.2 13.1-.5.5.6.9 1.2 1.4 1.8-3.5 4.5-11 5.1-15.6 1.2-4.8-4.2-5.1-12.2-.6-16.9 4.2-4.4 11.9-4.3 16.3.3zM295.4 216.6h-2.3c-3.1-7.2-6.2-14.5-9.3-21.8h2.8c2.5 6 5 12.1 7.7 18.5 2.6-6.3 5.1-12.4 7.7-18.5h2.7c-3.1 7.4-6.2 14.6-9.3 21.8z" />
              <path d="M23.7 180.4h-2.5v-19.3h-7.3v-2.2h17v2.2h-7.2v19.3z" />
              <path d="M232.5 158.9h2.4v19.3h12.2v2.2h-14.6v-21.5z" />
              <path d="M124.2 214.1v2.3h-14.6v-21.5h2.4v19.2h12.2zM144.1 214.1v2.3h-14.6v-21.5h2.4v19.2h12.2z" />
              <path d="M348 158.9h2.3v21.5H348v-21.5zM276.4 194.9h2.3v21.5h-2.3v-21.5zM312.1 216.4h-2.3v-21.5h2.3v21.5zM340 194.9h2.3v21.5H340v-21.5zM132.3 180.4H130v-21.5h2.3v21.5z" />
            </g>
          </g>
        </TLED>

        <Address>
          Austin Community College District
          <br />
          5930 Middle Fiskville Rd.
          <br />
          Austin, Texas 78752
          <br />
          <span className="tel">512-223-4ACC (4222)</span>
        </Address>
        <div>
          <Report
            href="https://fs7.formsite.com/accids/8fvbxzfirh/index.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Report issues and errors found in the ACC Catalog
          </Report>
        </div>
      </GridCell>
    </Grid>
  </StyledFooter>
);

export default Footer;

// <div className={footer__container}>
//     <div>
//       <ul className={listStyle}>
//         <li><Link to="http://www.austincc.edu/discover">About ACC</Link></li>
//         <li><Link to="http://www.austincc.edu/police">Campus Police</Link></li>
//         <li><Link to="http://www.austincc.edu/emergency-notifications">Emergency Information</Link></li>
//       </ul>
//     </div>
//     <div>
//       <ul className={listStyle}>
//         <li><Link to="http://www.austincc.edu/calendars/Linkcademic-calendar">Academic Calendar</Link></li>
//         <li ><Link to="http://www.austincc.edu/degrees-and-certificates/explore-educational-choices/Linkreas-of-study/programs-a-z">Academic &amp; Career Programs</Link></li>
//       </ul>
//     </div>
//     <div>
//       <ul className={listStyle}>
//         <li><Link to="http://www.austincc.edu/Linkpply-and-register/Linkdmission-steps">Admissions</Link></li>
//         <li><Link to="http://www.austincc.edu/locations/campuses">Campus Locations</Link></li>
//       </ul>
//     </div>
//     <div >
//       <div>
//
//       </div>
//       <div>
//
//       </div>
//     </div>
//   </div>



// WEBPACK FOOTER //
// ./src/components/Footer.js